import { render, staticRenderFns } from "./editRecord.vue?vue&type=template&id=4e8f1746&"
import script from "./editRecord.vue?vue&type=script&lang=js&"
export * from "./editRecord.vue?vue&type=script&lang=js&"
import style0 from "./editRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports